import { arrayOf } from "utils/helpers/array-of";
import { round } from "utils/math/round";

export const cameraAnimationTime = 125;

export const CAMERA_SCALE_STEP = 0.05;
// export const CAMERA_SCALE_STEP = 1;

export const CAMERA_MAX_SCALE = 5;
// export const CAMERA_MAX_SCALE = 64;

export const CAMERA_MIN_SCALE = 0.05;
// export const CAMERA_MIN_SCALE = 0.0625;

export const cameraScalesArr: Array<[name: string | number, scale: number]> = arrayOf(
  (CAMERA_MAX_SCALE - CAMERA_MIN_SCALE) / CAMERA_SCALE_STEP + 1,
  (i, length) => {
    const scale = round((length - i) * CAMERA_SCALE_STEP, 2);
    return [scale, scale];
  },
);

// export const cameraScalesArr: Array<[name: string | number, scale: number]> = [
//   [64, 64],
//   [32, 32],
//   [16, 16],
//   [12, 12],
//   [8, 8],
//   [6, 6],
//   [4, 4],
//   [3, 3],
//   [2, 2],
//   [1, 1],
//   [0.75, 0.75],
//   [0.5, 0.5],
//   [0.25, 0.25],
//   [0.125, 0.125],
//   [0.0625, 0.0625],
// ];
